import type { RouteComponentBundle, RouteComponentBundleWithCTX } from './types'

type DefaultParams = { [K in string]?: string | undefined }

type BundleCreator = {
  (obj: RouteComponentBundle): RouteComponentBundle
  <Params extends DefaultParams>(obj: RouteComponentBundle<Params>): RouteComponentBundle<Params>
  <Params extends DefaultParams, CTX>(obj: RouteComponentBundleWithCTX<Params, CTX>): RouteComponentBundleWithCTX<Params, CTX>
}

export const createRouteBundle: BundleCreator = (obj: any) => obj
